
<template>
    <a v-if="isPdf(document.file_path)" target="_blank" :href="previewUrl">
        {{ document.file_name }}
        <a style="display: inline-flex; align-items: center" target="_blank" v-on:click.stop :href="downloadUrl">
            <i class="mdi mdi-download"></i>
        </a>
    </a>
    <a v-else-if="isImage(document.file_path)" @click="previewImage()" href="javascript:void(0);">
        {{ document.file_name }}
        <a style="display: inline-flex; align-items: center" target="_blank" v-on:click.stop :href="downloadUrl">
            <i class="mdi mdi-download"></i>
        </a>
    </a>
    <a v-else target="_blank" :href="downloadUrl">
        {{ document.file_name }} <i class="mdi mdi-download"></i>
    </a>
    <vue-easy-lightbox
        moveDisabled
        :visible="previewVisible"
        :imgs="streamUrl"
        :index="0"
        @hide="hidePreview"
    ></vue-easy-lightbox>
</template>


<script>
import VueEasyLightbox from 'vue-easy-lightbox'
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css'

export default {
    name: "DocumentPreview",
    props: {
        document: Object,
        previewUrl: String,
        streamUrl: String,
        downloadUrl: String,
    },
    data() {
        return {
            previewVisible: false
        };
    },
    components: {
        VueEasyLightbox,
    },
    methods: {
        isPdf(src) {
            return src.endsWith(".pdf");
        },
        isImage(src) {
            return src.endsWith(".jpg") || src.endsWith(".jpeg") || src.endsWith(".png");
        },
        previewImage() {
            this.previewVisible = true;
        },
        hidePreview() {
            this.previewVisible = false;
        }
    }
}
</script>
<style scoped>

</style>
